import React, { Component, PropTypes } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { ModalManager} from '../helpers/index';
import SpPageBuilderModal from '../helpers/modal';
import EditPanelManager from '../helpers/EditPanelManager';
import RowSaveModal from '../helpers/RowSaveModal';
import { changeIdofBlock } from '../helpers/commonHelper';

import {
  addRowBottom,
  toggleRow,
  deleteRow,
  cloneRow,
  saveSetting,
  pasteRow,
  innerAddRowBottom,
  deleteAddon,
  innerCloneRow,
  innerToggleRow,
  innerPasteRow
} from '../actions/index';

class RowSettings extends Component {

  _getSettingObjects(){
    return{
      index: this.props.index,
      settings: {
        colIndex: this.props.colIndex,
        addonIndex: this.props.innerRowIndex
      }
    }
  }

  _addRowButtonHandle(){
    if (typeof this.props.innerRowIndex === 'undefined') {
      var sectionType = 'row';
    } else {
      var sectionType = 'inner_row';
    }

    ModalManager.open(
      <SpPageBuilderModal
        sectionType={sectionType}
        saveSetting={this.props.onSettingsClick}
        rowIndex={ this.props.index }
        colIndex={ this.props.colIndex }
        addonIndex={ this.props.innerRowIndex }
        settings={ this.props.row.settings }
        onRequestClose={() => true}
        />
    );
  }

  _duplicateRowClickHandle(){
    const options = this._getSettingObjects();

    typeof this.props.innerRowIndex === 'undefined'
    ? this.props.cloneRow(this.props.index)
    : this.props.innerCloneRow(options)
  }

  _addNewRowClickHandle(){
    const options = this._getSettingObjects();

    typeof this.props.innerRowIndex === 'undefined'
    ? this.props.addRowBottom(this.props.index)
    : this.props.innerAddRowBottom(options)
  }

  _rowVisbilityToggleHandle(){
    const options = this._getSettingObjects();

    typeof this.props.innerRowIndex === 'undefined'
    ? this.props.toggleRow(this.props.row.id)
    : this.props.innerToggleRow(options)
  }

  _deleteRowClickHandle(){
    const options = this._getSettingObjects();

    if (window.confirm(Joomla.JText._("COM_SPPAGEBUILDER_DELETE_ROW_CONFIRMATION"))) {
      typeof this.props.innerRowIndex === 'undefined'
      ? this.props.deleteRow(this.props.index)
      : this.props.innerDeleteRow(options)
    }
  }

  _saveRowAsSection(){
    ModalManager.open(
      <RowSaveModal row={this.props.row} />
    );
  }



  _copyRowClickHandle(){
    localStorage.setItem('sppb_clipboard', JSON.stringify(this.props.row));

    sppbNotify(Joomla.JText._('COM_SPPAGEBUILDER_ROW_COPIED'))
  }

  _pasteClickHandle(){
    if (typeof this.props.innerRowIndex === 'undefined') {
      var dataType = 'row';
    } else {
      var dataType = 'inner_row';
    }

    let data = null;

    try {
      data = JSON.parse(localStorage.getItem('sppb_clipboard'))
    } catch (error) {
      console.log(error)
    }

    if(data !== null){
      data = changeIdofBlock(data)
      this.props.pasteSave({
        index: this.props.index,
        type: dataType,
        colIndex: this.props.colIndex,
        addonIndex: this.props.innerRowIndex,
        data: data
      });
  
      sppbNotify(Joomla.JText._('COM_SPPAGEBUILDER_PASTED'))
    }
  }

  render(){
    return(
      this.props.row.visibility
      ?
      <div className="sp-pagebuilder-row-settings">
        <ul>

            <li title={Joomla.JText._("COM_SPPAGEBUILDER_ROW_OPTIONS")}>
              <a href="#"
                onClick={(e)=>{
                  e.preventDefault();
                  //this._addRowButtonHandle();
                  EditPanelManager.resetAll();
                  if (typeof this.props.innerRowIndex === 'undefined') {
                    EditPanelManager.setType('row');
                  } else {
                    EditPanelManager.setType('inner_row');
                    EditPanelManager.setColIndex(this.props.colIndex);
                    EditPanelManager.setInnerRowIndex(this.props.innerRowIndex);
                  }
                  
                  EditPanelManager.setRowIndex(this.props.index);
                  EditPanelManager.setRowSettings(this.props.row);

                  EditPanelManager.showEditPanel();
                }}>
                <i className="pbfont pbfont-settings"></i>
              </a>
            </li>
            <li title={Joomla.JText._("COM_SPPAGEBUILDER_DUPLICATE_ROW")}>
              <a href="#"
                onClick={(e) =>{
                  e.preventDefault();
                  this._duplicateRowClickHandle()
                }}>
                <i className="pbfont pbfont-duplicate"></i>
              </a>
            </li>
            

            {
              this.props.innerRowIndex === undefined &&
                <li title={Joomla.JText._("COM_SPPAGEBUILDER_SAVE_ROW")}>
                  <a href="#"
                    onClick={(e) =>{
                      e.preventDefault();

                      this._saveRowAsSection()
                    }}>
                    <i className="pbfont pbfont-save"></i>
                  </a>
                </li>
            }

            <li title={Joomla.JText._("COM_SPPAGEBUILDER_COPY_ROW")}>
              <a href="#"
                onClick={(e) =>{
                  e.preventDefault();
                  this._copyRowClickHandle()
                }}>
                <i className="pbfont pbfont-copy"></i>
              </a>
            </li>
            
            <li title={Joomla.JText._("COM_SPPAGEBUILDER_PASTE_ROW")}>
              <a href="#"
                onClick={(e) =>{
                  e.preventDefault();
                  this._pasteClickHandle()
                }}>
                <i className="pbfont pbfont-paste"></i>
              </a>
            </li>
          
            <li title={Joomla.JText._("COM_SPPAGEBUILDER_DISABLE_ROW")}>
              <a href="#"
                onClick={ (e) => {
                  e.preventDefault();
                  this._rowVisbilityToggleHandle();
                }}
                >
                { this.props.row.visibility ? <span><i className="pbfont pbfont-blind"></i></span> : <span><i className="pbfont pbfont-eye"></i></span> }
              </a>
            </li>
            <li title={Joomla.JText._("COM_SPPAGEBUILDER_DELETE_ROW")}>
              <a href="#"
                onClick={(e)=>{
                  e.preventDefault();
                  this._deleteRowClickHandle();
                }}>
                <i className="pbfont pbfont-trash"></i>
              </a>
            </li>

        </ul>
      </div>
      :
      <div className="sp-pagebuilder-enable-row">
        <a href="#"
          onClick={ (e) => {
            e.preventDefault();
            this._rowVisbilityToggleHandle();
          }}
          >
          <span><i className="pbfont pbfont-eye"></i> {Joomla.JText._("COM_SPPAGEBUILDER_ENABLE_ROW")}</span>
        </a>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {state};
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSettingsClick: (options) => {
      dispatch(saveSetting(options))
    },
    addRowBottom: (index) => {
      dispatch(addRowBottom(index))
    },
    cloneRow: (index) => {
      dispatch(cloneRow(index))
    },
    toggleRow: (id) => {
      dispatch(toggleRow(id))
    },
    deleteRow: (index) => {
      dispatch( deleteRow( index ) )
    },
    innerAddRowBottom: (options) => {
      dispatch( innerAddRowBottom( options ) )
    },
    innerCloneRow: (options) => {
      dispatch( innerCloneRow( options ) )
    },
    innerToggleRow: (options) => {
      dispatch( innerToggleRow( options ) )
    },
    innerDeleteRow: (options) => {
      dispatch( deleteAddon( options ) )
    },
    pasteSave: (options) => {
      if (options.type === 'row') {
        dispatch( pasteRow( options ) );
      } else {
        dispatch( innerPasteRow( options ) )
      }
    }
  }
}

export default  connect(
  mapStateToProps,
  mapDispatchToProps
)(RowSettings)



// WEBPACK FOOTER //
// ./src/components/RowSettings.js